/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchPageContext
 */
export interface SourcingSearchPageContext {
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchPageContext
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchPageContext
     */
    currentPage?: number;
}

/**
 * Check if a given object implements the SourcingSearchPageContext interface.
 */
export function instanceOfSourcingSearchPageContext(value: object): value is SourcingSearchPageContext {
    return true;
}

export function SourcingSearchPageContextFromJSON(json: any): SourcingSearchPageContext {
    return SourcingSearchPageContextFromJSONTyped(json, false);
}

export function SourcingSearchPageContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchPageContext {
    if (json == null) {
        return json;
    }
    return {
        
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
    };
}

export function SourcingSearchPageContextToJSON(value?: SourcingSearchPageContext | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'pageSize': value['pageSize'],
        'currentPage': value['currentPage'],
    };
}

